module.exports = __webpack_public_path__ + "img/51.776c9bc5.jpg";